// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { Skeleton } from '@crehana/ui';

import {
  DraggableContentContainer,
  SliderContainer,
} from './CategorySlider.styles';
import SliderItem from './SliderItem';

const Loader = () => {
  const mockData = new Array(5).fill('');

  return (
    <div className="relative overflow-hidden w-screen sm:w-full left-0 flex flex-col sm:flex-row items-center justify-center">
      <SliderContainer className="overflow-hidden py-24 m-auto">
        <DraggableContentContainer
          translateX="default"
          className="flex flex-row items-start"
        >
          {mockData.map((_, index) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: legacy code - suspicious/noArrayIndexKey
            <SliderItem isSelected={false} key={`cl-item-${index}`} />
          ))}
        </DraggableContentContainer>
      </SliderContainer>
      <Skeleton
        className="sm:hidden w-64 h-32 rounded-10 "
        isDark
        css={`
          background: rgba(0, 0, 0, 0.49);
        `}
      />
    </div>
  );
};

export default Loader;
